module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/gunma-h1-b-58f13aca59fd7eaa0b3c02126d68c626.svg";